/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-cycle */
import baseApi from '@features/base/BaseSlice';
import qrCode from './qrcode';
import { QrCodeEmailParams, QrCodeProps, QrCodesApiProps } from './types';

// Add Tag to the list of tags to be invalidated when the list of countries is updated
const qrCodeTag = baseApi.enhanceEndpoints({ addTagTypes: [qrCode.tagType] });
const countryAPi = qrCodeTag.injectEndpoints({
  endpoints: (builder) => ({
    getQrCodes: builder.query<QrCodesApiProps, number>(qrCode.getCodesByWorker()),
    getHistoryQrCodes: builder.query<QrCodesApiProps, number>(qrCode.getHistoryCodesByWorker()),
    sendQrCodeEmail: builder.mutation<void, QrCodeEmailParams>(qrCode.sendEmail()),
    addWorkerQrCode: builder.mutation<QrCodesApiProps, Partial<QrCodeProps>>(qrCode.createQrCode()),
  }),
  overrideExisting: false,
});

export const {
  useGetQrCodesQuery,
  useGetHistoryQrCodesQuery,
  useSendQrCodeEmailMutation,
  useAddWorkerQrCodeMutation,
} = countryAPi;
